









import { defineComponent, PropType, computed, toRefs, ref } from '@vue/composition-api';
import { AdgroupFormData } from '@tt4b/ttam-enums';
import tiktokPlacementOnly from './index';
import { FlowType, InventoryFlow } from '@ad/tt_ads_common_enums';
import { AdgroupConfig, CampaignFormData } from '@tt4b/ttam-enums/src/types';

const name = 'ttam-tiktok-placement-only-compose';

export default defineComponent({
  name,
  components: {
    TtamPlacementTiktokOnly: tiktokPlacementOnly.TtamPlacementTiktokOnly,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, adgroupConfig } = toRefs(props);
    const _isTiktokOnly = computed({
      get: () =>
        Boolean(
          adgroupData.value.inventoryFlowType === FlowType.SELECTED &&
            adgroupData.value.inventoryFlow.includes(InventoryFlow.TIKTOK),
        ),
      set: v => {
        const inventory = {
          inventoryFlowType: v ? FlowType.SELECTED : FlowType.AUTO,
          inventoryFlow: v ? [InventoryFlow.TIKTOK] : [InventoryFlow.TIKTOK, InventoryFlow.TIKTOKADNETWORK],
        };
        emit('change', inventory);
      },
    });

    const { disabled } = tiktokPlacementOnly.useSwitchPropsDisabled({
      adgroupConfig,
    });

    return {
      name,
      _isTiktokOnly,
      disabled,
    };
  },
});
